// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3oHf8","itemTitle":"ClientEmergencyInfo_itemTitle__1Fdup","itemText":"ClientEmergencyInfo_itemText__xLiWl"};